document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('customPromoPopup');
  if (!popup) return;

  // ---- Read Configuration from Theme Editor ----
  const delayMs = parseInt(popup.dataset.delay || 3) * 1000;
  const frequencyDays = parseInt(popup.dataset.frequency || 7);
  const showOnAll = popup.dataset.showAll === 'true';
  const targetCollections = (popup.dataset.targetCollections || '').split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
  
  const currentTemplate = popup.dataset.template;
  const currentCollection = popup.dataset.collection;

  // ---- Targeting Logic ----
  
  // 1. Ensure we are actually on a collection page
  if (currentTemplate !== 'collection') {
    return;
  }

  // 2. Check if we should show it on this specific collection
  if (!showOnAll && !targetCollections.includes(currentCollection)) {
    return; 
  }

  // 3. Frequency Logic (Local Storage)
  const storageKey = 'promoPopupClosedAt';
  const lastClosed = localStorage.getItem(storageKey);
  
  if (lastClosed && frequencyDays > 0) {
    const now = new Date().getTime();
    const daysSinceClosed = (now - parseInt(lastClosed)) / (1000 * 60 * 60 * 24);
    if (daysSinceClosed < frequencyDays) {
      return; // Stop if the required days haven't passed
    }
  }

  // ---- Popup Actions ----
  const closeBtn = popup.querySelector('.promo-popup-close');

  const openPopup = () => {
    popup.style.display = 'flex';
    requestAnimationFrame(() => {
      popup.classList.add('is-visible');
    });
  };

  const closePopup = () => {
    popup.classList.remove('is-visible');
    setTimeout(() => { popup.style.display = 'none'; }, 300);
    localStorage.setItem(storageKey, new Date().getTime().toString());
  };

  // Trigger the delay
  setTimeout(openPopup, delayMs);

  // Event Listeners
  closeBtn.addEventListener('click', closePopup);
  popup.addEventListener('click', (e) => {
    if (e.target === popup) closePopup(); 
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
      closePopup();
    }
  });
});